export var EventSponsorRequestStatus;
(function (EventSponsorRequestStatus) {
    EventSponsorRequestStatus["Pending"] = "pending";
    EventSponsorRequestStatus["Approved"] = "approved";
    EventSponsorRequestStatus["Rejected"] = "rejected";
})(EventSponsorRequestStatus || (EventSponsorRequestStatus = {}));
